
import { Component, Vue } from "vue-property-decorator";
import Pagination from "@/components/Pagination/index.vue";
import {
    OptionSettingsDto,
    VipPaySettingService,
    QRCodeContentSetting,
} from "@/api/service-proxies";
import PagedListBase, {
    PagedRequestDto,
} from "@/lib/view-base/paged-list-base";
import PaymentDialogEdit from "../components/paymentDialogEdit.vue";
import PaymentDialogSet from "../components/paymentDialogSet.vue"
import EditDialog from "./components/edit-dialog.vue";
class PageUserRequest extends PagedRequestDto {
    name!: string;
    isQRCode = true;
}

@Component({
    name: "Payment-setting",
    components: {
        Pagination,
        PaymentDialogEdit,
        PaymentDialogSet
    },
})
export default class extends PagedListBase<PageUserRequest, OptionSettingsDto> {
    request = new PageUserRequest();
    private payService = new VipPaySettingService();
    changeVisible: boolean = false;
    created() {
        this.refresh();
    }
    getpage(finishCallback: Function): void {
        this.payService
            .getAllSettings(
                this.request.name,
                this.request.isQRCode,
                this.request.sorting,
                this.request.skipCount,
                this.request.maxResultCount
            )
            .then((result) => {
                this.list = result.items;
                this.showPaging(result);
                this.isTableLoading = false;
            });
    }
    handleAddSchoolManager(row: OptionSettingsDto) {
        this.payService
            .getVipPriceSettingByTenantId(row.schoolId,true)
            .then((result) => {console.log(result);
                (
                    this.$refs.paymentDialog as PaymentDialogEdit).open(
                    row.schoolId,
                    row.schoolName,
                    result
                );
            });
    }
      handleSetting(qrCodeSetting:QRCodeContentSetting,schoolName) {
        (this.$refs.paymentDialogSet as PaymentDialogSet).open(qrCodeSetting,schoolName);
    }
    listenEventHide() {
        this.changeVisible = false;
    }
}
